import { CIcon } from '~/icons/types'

export const ciFashion: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm22.442 8.219-3.471-3.338A4.92 4.92 0 0 0 15.543 3.5H8.455a4.918 4.918 0 0 0-3.426 1.384L1.558 8.223a.942.942 0 0 0 0 1.338l2.065 2.066a.937.937 0 0 0 1.257.073l1.73-1.341v9.2a.946.946 0 0 0 .945.944h8.889a.946.946 0 0 0 .945-.944v-9.2l1.717 1.328a.94.94 0 0 0 1.274-.058l2.063-2.063a.944.944 0 0 0 0-1.34l-.001-.007ZM14.1 4.5a2.16 2.16 0 0 1-4.2 0h4.2Zm5.63 6.4-2.536-1.962a.5.5 0 0 0-.8.395l.05 10.167-8.834.056V9.333a.5.5 0 0 0-.81-.395l-2.473 1.981-2.071-1.981L5.723 5.6a3.926 3.926 0 0 1 2.732-1.1h.429a3.153 3.153 0 0 0 6.231 0h.428c1.02-.002 2 .392 2.734 1.1L21.7 8.891 19.73 10.9Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'fashion',
  type: 'thin'
}
